import { API_URLS } from '../configuration/apiConstants';
import { apiFetch } from '../configuration/apiFetch';


export const getAppUsers =  () => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.USERS_BY_APP,
    api: process.env.REACT_APP_AUTH,
    originApp: true
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

export const getAppRoles =  () => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.ROLES_BY_APP(process.env.REACT_APP_ORIGIN_APP_ID),
    api: process.env.REACT_APP_AUTH,
    originApp: true
  }

  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response.roles)
    })
  })
  return dataFetch
}

export const getGlobalUsers = (params) => {
  const fetchSettings = {
    method: "GET",
    url: API_URLS.GLOBAL_USERS,
    api: process.env.REACT_APP_AUTH,
    originApp: true,
    params: {
      ...params,
      filterUsersWithoutEmployeeId: false,
      filterUsersWithoutOfficeLocation: false,
      filterUsersWithoutMail: true,
      filterUsersWithoutMailNickName: false
    }
  }

  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

  export async function updateUser({userId, newRoleId, active = true, successMsg}) {
    const fetchSettings = {
      method: "PUT",
      url: API_URLS.USER_UPDATE_ROLE,
      api: process.env.REACT_APP_AUTH,
      originApp: true,
      data: {
        userId,
        newRoleId,
        active
      },
      params: { register: true },
      successMsg,
    }
    const dataFetch = new Promise ((resolve) => {
      apiFetch(fetchSettings).then((response)=>{
        resolve(response)
      })
    })
    return dataFetch
  }